import Component from './Add.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionAdd', Component);
  },
};
